import { TestimonialItem } from './TestimonialsBlock';

const Testimonial = (props) => {
  return (
    <div className="flex justify-end">
      <div className="max-w-[500px] text-left">
        <TestimonialItem testimonial={props} index={1} />
      </div>
    </div>
  );
};
export default Testimonial;
